import { render } from "./VerticalNavMenuHeader.vue?vue&type=template&id=49f28175"
import script from "./VerticalNavMenuHeader.vue?vue&type=script&lang=js"
export * from "./VerticalNavMenuHeader.vue?vue&type=script&lang=js"
script.render = render

export default script